<template>
  <v-card :loading="loading" class="align-stretch" height="100%">
    <v-card-title>
      Tariff Details
      <v-spacer></v-spacer>
      <v-btn color="secondary" x-small @click="editTariffOpen=!editTariffOpen" :disabled="loading || disableIfSoldAndNotForApproval"><v-icon small>edit</v-icon></v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <p class="mb-1 text-caption">Tariff Name</p>
          <p><b>{{getTelcoTariffByID.name | isEmpty}}</b></p>
        </v-col>
        <v-col cols="12" md="4">
          <p class="mb-1 text-caption">Tariff Price</p>
          <p><b>{{getTelcoTariffByID.price | formatCurrency | isEmpty}}</b></p>
        </v-col>
        <v-col cols="12" md="4">
          <p class="mb-1 text-caption">Contract Length</p>
          <p><b>{{currentProduct.contract_length_months}} Months</b></p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <p class="mb-1 text-caption">Promo Length</p>
          <p><b>{{getTelcoPromoByID.name | isEmpty}}</b></p>
        </v-col>
        <v-col cols="12" md="4">
          <p class="mb-1 text-caption">Promo Price</p>
          <p><b>{{getTelcoPromoByID.price | formatCurrency | isEmpty}}</b></p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="mb-1 text-caption">Add ons</p>
          <template v-if="getTelcoAddons.length===0">
            <p><b>No addons selected</b></p>
          </template>
          <template v-else>
            <v-chip-group column>
              <template v-for="(item,itemI) in getTelcoAddons">
                <v-chip x-small :key="itemI">{{item}}</v-chip>
              </template>
            </v-chip-group>
          </template>
        </v-col>
      </v-row>
    </v-card-text>
    <TelcoTariffDetailsDialog :dialogOpen="editTariffOpen" @close-dialog="editTariffOpen=false;" />
  </v-card>
</template>

<script>
  import {mapState,mapGetters,mapActions} from 'vuex';
  import TelcoTariffDetailsDialog from './TelcoTariffDetailsDialog';
  export default {
    components: {TelcoTariffDetailsDialog},
    data() {
      return {
        editTariffOpen: false,
        tariff: {},
        promo: {},
        loading: false
      }
    },
    filters: {
      isEmpty: (val)=>{
        return (val!==''&&val!==undefined&&val!==null)?val:'-';
      }
    },
    computed: {
      ...mapState('products', ['currentProduct']),
      ...mapGetters('products',['getTelcoPromos','getTelcoAddons']),
      ...mapGetters('productTelco',['getTelcoTariffByID','getTelcoPromoByID']),

      disableIfSoldAndNotForApproval() {
        return this.currentProduct.sold_date!==null&&this.currentProduct.status!=='For Approval';
      },
    },
    methods: {
      ...mapActions('products',['getAllTariffs','fetchTelcoAddons']),
      ...mapActions('productTelco',['fetchTelcoTariffs']),
    },
    
    async mounted () {
      let tariffVersion = this.currentProduct.tariff_version.replace('TARIFF_V','');
      let productKind = this.currentProduct.kind;
      try {
        this.loading = true;
        await this.fetchTelcoTariffs(tariffVersion,productKind);
        await this.fetchTelcoAddons(tariffVersion);
        this.loading = false;
      }catch(err) {
        this.loading = false;
      }
    },
  }
</script>

<style>

</style>
